import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { LinearProgressBar } from '../../../shared';
import { useSelector } from 'react-redux';
import { getDifferenceBetweenDateRange } from '../../../../utility';
import { fetchImagesFromS3Bucket } from '../../../../utility/aws-utility';

const Prescriber = (props) => {
    const [avatarSrc, setAvatarSrc] = useState(' ');
    const { prescriber, handleModal } = props;
    const { company } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector(
        (state) => state.filter,
    );

    const hideTotalDetails = useMemo(() => {
        let isHidden = false;

        switch (company.id) {
            case 3: // Tepmetko
            case 16: // Bavencio
            case 66: // replimune
            case 64: // replimune
            case 102:
                isHidden = true;
                break;
            default:
                isHidden = false;
                break;
        }

        return isHidden;
    }, [company.id]);
    const { bool, text } = useMemo(() => {
        let bool = false;
        let text = 'Patient(s)';
        switch (company.id) {
            case 18: // Yescarta
            case 20: // Tecartus
            case 34: // CAR-T HOPE
            case 37: // Xevinapant
            case 41: // Regenrons
            case 51: // Regenrons
            case 53: // Regenrons
            case 59: // Regenrons
            case 72: // Regenrons
            case 90: // Regenrons
            case 92: // Regenrons
            case 64: // replimune
            case 66: // replimune
                bool = true;
                text = 'Engagement(s)';
                break;
            case 33: // Rezlidhia
            case 62: // Gavreto
                bool = false;
                text = 'Bottle(s)';
                break;
            case 40: // OJEMDA
                bool = false;
                text = 'Rx';
                break;
            default:
                bool = false;
                text = 'Patient(s)';
                break;
        }

        return { bool, text };
    }, [company.id]);

    // useEffect(() => {
    //     const fetchPrescriberImage = async() => {
    //         if (!prescriber.id) {
    //             setAvatarSrc(' ');
    //             return;
    //         }
    //         const imageUrl = await fetchImagesFromS3Bucket(process.env.MIX_AWS_BUCKET, `Rx_images/${prescriber.id}.jpg`);
    //         setAvatarSrc(imageUrl);
    //     };
    //     fetchPrescriberImage();
    // }, [prescriber.id]);

    return (
        <Box className="padding-8px hover-prescriber-box" onClick={handleModal}>
            <Box className="flex-row mb-12px ">
                <Box className="pr-12px">
                    <Avatar
                        alt={prescriber.name}
                        className="prescriber-profile"
                        src={`https://pfiq-v1-dev.s3.us-west-2.amazonaws.com/Rx_images/${prescriber?.id}.jpg`}
                    />
                </Box>
                <Box>
                    <Typography className="text-xs-medium gray-900">
                        Dr. {prescriber.name}
                    </Typography>
                    {!hideTotalDetails && (
                        <Typography className="text-xs-medium gray-500">
                            {prescriber.prescriptions} Total {text} this{' '}
                            {getDifferenceBetweenDateRange(
                                startDateRange,
                                endDateRange,
                            )}
                        </Typography>
                    )}
                </Box>
            </Box>
            {!hideTotalDetails && (
                <LinearProgressBar
                    tooltipText={prescriber.prescriptions}
                    value={prescriber.percentage}
                />
            )}
        </Box>
    );
};

export default React.memo(Prescriber);
